import { box, qs, type Http } from './core';

export interface MailboxSettings {
  timeZone?: string;
  language?: { locale?: string };
  workingHours?: { daysOfWeek: string[]; startTime: string; endTime: string; timeZone?: { name?: string } };
  automaticRepliesSetting?: { status: string };
}
export interface Person {
  id: string;
  displayName: string | null;
  email: string | null;
  jobTitle?: string | null;
}

export function mailboxSettingsApi(h: Http) {
  return { get: (mailbox?: string) => h.json<MailboxSettings>('mailboxSettings', 'GET', `${box(mailbox)}/mailboxSettings`) };
}

/** Tìm người nhận: người hay liên hệ (People) + tra danh bạ công ty (users, theo tên / email). */
export function peopleApi(h: Http) {
  return {
    async search(text: string, top = 10): Promise<Person[]> {
      const t = text.trim().replace(/["']/g, '');
      if (t.length < 2) return [];
      const q = new URLSearchParams({ $search: `"${t}"`, $top: String(top) });
      const r = await h.json<{ value: Array<{ id: string; displayName: string | null; scoredEmailAddresses?: Array<{ address: string }>; jobTitle?: string | null }> }>('people', 'GET', `/me/people?${qs(q)}`);
      return r.value.flatMap((p) => {
        const email = p.scoredEmailAddresses?.[0]?.address ?? null;
        return email ? [{ id: p.id, displayName: p.displayName, email, jobTitle: p.jobTitle }] : [];
      });
    },
    async users(text: string, top = 10): Promise<Person[]> {
      const t = text.trim().replace(/["']/g, '');
      if (t.length < 2) return [];
      const q = new URLSearchParams({ $search: `"displayName:${t}" OR "mail:${t}"`, $select: 'id,displayName,mail,jobTitle', $top: String(top) });
      const r = await h.json<{ value: Array<{ id: string; displayName: string | null; mail: string | null; jobTitle?: string | null }> }>('people', 'GET', `/users?${qs(q)}`, undefined, { ConsistencyLevel: 'eventual' });
      return r.value.map((u) => ({ id: u.id, displayName: u.displayName, email: u.mail, jobTitle: u.jobTitle }));
    },
  };
}
